export default "__VITE_ASSET__LFmaBNKO__"